



































































































































































































































import store from '../store'
import { inputs, printExport, touchScreen } from '../mixins/mixins'
import { isTestMode } from '@/mla-shared'
import { Assumption, Cost } from '@/data/fields'
const Finance = require('financejs')

export default {
  mixins: [ inputs, printExport, touchScreen ],

  data (this:any) {
    return {
      title: 'Results',
      finance: new Finance(),
      scenario: store.state.selectedScenario,
      scenarioLifeCycle: store.state.selectedScenario.value.lifeCycle,
      lifeCycles: ['Perennial', 'Short term'],
      updateResultsKey: 0,
      isTouchScreen: this.detect(),
      testing: isTestMode()
    }
  },

  mounted() {
    // console.log(store.state)
  },

  watch: {
    scenario: function (this:any) {
      this.updateResultsKey += 1
    },
    scenarioLifeCycle: function (this:any) {
      this.updateResultsKey += 1
    }
  },

  computed: {

    lifeCycleKey: function (this:any) {
      return this.scenarioLifeCycle === 'Perennial' ? 'perennial' : 'shortTerm'
    },

    // Results Headings
    resultsHeaders: function () {
      return [
        { text: 'Measurement', value: 'measurement' },
        { text: 'Value', value: 'value' },
        { text: 'Decision criterion', value: 'criterion' }
      ]
    },

    // Results Data
    results: function (this:any) {
      return [
        {
          measurement: 'Net Present Value (NPV)',
          description: 'The net sum of the discounted values of the future income and costs associated with the pasture improvement. Represents the amount of extra money you would have in current dollar terms above what you earned at your required rate of return, at the end of the investment period.',
          value: this.NPV * this.area,
          criterion: 'Undertake paddock development if NPV is greater than zero at the required discount rate.',
          tip: '',
          money: true
        },
        {
          measurement: 'Internal Rate of Return (IRR)',
          description: 'The discount rate  that sets the NPV of the investment to zero ie. the breakeven discount rate for the investment. If all money for the investment was borrowed, the IRR would represent the maximum interest rate the investor could afford to pay on the loan without losing money.',
          value: this.IRR,
          criterion: 'Undertake paddock development if IRR is greater than or equal to your specified discount rate.',
          tip: '',
          percentage: true
        },
        {
          measurement: 'Peak debt',
          description: 'The highest level of cumulative debt during the life of the investment.',
          value: this.peakDebt * this.area,
          criterion: 'Can you cover this cash flow with equity or borrowed funds?',
          tip: 'The year when the peak debt occurs.',
          money: true
        },
        {
          measurement: 'Year of peak debt',
          description: 'The year when the peak debt occurs.',
          value: this.peakDebtYear,
          criterion: '',
          tip: ''
        },
        {
          measurement: 'Break even year',
          description: 'The year in which cumulative cash flow for the investment becomes positive.',
          value: this.breakEvenYear,
          criterion: 'Can you cover a negative cash flow for this length of time?',
          tip: ''
        }/*,
        {
          measurement: 'Break even peak stocking rate (DSE/ha)',
          description: 'The peak stocking rate required to just break even at the chosen discount rate ie. all costs are covered but there is no profit. ',
          value: 0,
          criterion: 'Is this a realistic/achieveable figure for the pasture after allowing for risk?',
          tip: ''
        },
        {
          measurement: 'Break even peak gross margin ($/DSE)',
          description: 'The peak gross margin per DSE required to just breakeven at the chosen discount rate ie. all costs are covered but there is no profit. ',
          value: 0,
          criterion: 'Is this a realistic/achieveable figure for the pasture after allowing for risk?',
          tip: ''
        }*/
      ]
    },

    // Chart data prop
    stockingRateChartData: function (this:any) {
      return {
        labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
        datasets: [
          {
            label: 'DSE/Ha',
            backgroundColor: '#007549',
            borderColor: '#000',
            borderWidth: 2,
            data: this.twentyYearValues.stockingRate.array.map((val:number, year:number) => {
              if (year < this.pastureLife) {
                return Math.round(val)
              }
            }),
            fill: false
          },
          {
            label: '$/DSE',
            backgroundColor: '#B9CD96',
            borderColor: '#B9CD96',
            data: this.twentyYearValues.grossMargin.array.map((val:number, year:number) => {
              if (year < this.pastureLife) {
                return Math.round(val)
              }
            }),
            fill: false
          }
        ]
      }
    },

    // Chart options prop
    stockingRateChartOptions: function (this:any) {
      return {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          x: {
            display: true,
            beginAtZero: true,
            title: {
              display: true,
              text: 'Pasture life (years after improvement)',
              color: '#000',
              font: {
                size: 14
              },
              padding: {
                top: 15
              }
            },
            ticks: {
              color: '#000'
            },
            grid: {
              color: 'rgba(0,0,0,0.05)',
              tickColor: '#000',
              borderColor: '#000'
            }
          },
          y: {
            display: true,
            beginAtZero: true,
            title: {
              display: true,
              text: 'Gross margin / stocking rate value',
              color: '#000',
              font: {
                size: 14
              },
              padding: {
                bottom: 15
              }
            },
            ticks: {
              color: '#000'
            },
            grid: {
              color: 'rgba(0,0,0,0.05)',
              tickColor: '#000',
              borderColor: '#000'
            }
          }
        },
        plugins: {
          chartAreaBorder: {
            borderColor: 'rgba(0,0,0,0.1)',
            borderWidth: 1,
          },
          tooltip: {
            callbacks: {
              title: function(context:any) {
                return 'Year: ' + context[0].label
              }
            }
          },
          legend: {
            display: true,
            labels: {
              color: '#000',
              font: {
                size: 14
              }
            }
          }
        }
      }
    },

    // Chart data prop
    netIncomeChartData: function (this:any) {
      return {
        labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
        datasets: [
          {
            label: 'Additional cumulative net income',
            type: 'bar',
            backgroundColor: '#007549',
            borderColor: '#000',
            borderWidth: 2,
            data: this.twentyYearValues.cumulativeNetCashFlowAfterInterestTax.array.map((val:number, year:number) => {
              if (year <= this.pastureLife) {
                return Math.round(val) * store.state.selectedScenario.value.areas[this.lifeCycleKey]
              }
            }).slice(1, 20),
            callback: function (value:any) {
              return '$' + value
            }
          }
        ]
      }
    },

    // Chart options prop
    netIncomeChartOptions: function (this:any) {
      let ctx = this;
      return {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          x: {
            display: true,
            beginAtZero: true,
            title: {
              display: true,
              text: 'Pasture life (years after improvement)',
              color: '#000',
              font: {
                size: 14
              },
              padding: {
                top: 15
              }
            },
            ticks: {
              color: '#000'
            },
            grid: {
              color: 'rgba(0,0,0,0.05)',
              tickColor: '#000',
              borderColor: '#000'
            }
          },
          y: {
            display: true,
            beginAtZero: false,
            title: {
              display: true,
              text: 'Additional cumulative net income ($)',
              color: '#000',
              font: {
                size: 14
              },
              padding: {
                bottom: 15
              }
            },
            ticks: {
              color: '#000',
              callback: function (value:any) {
                return ctx.$options.filters.money(value)
              }
            },
            grid: {
              color: 'rgba(0,0,0,0.05)',
              tickColor: '#000',
              borderColor: '#000'
            }
          }
        },
        plugins: {
          chartAreaBorder: {
            borderColor: 'rgba(0,0,0,0.1)',
            borderWidth: 1,
          },
          tooltip: {
            callbacks: {
              label: function(context:any) {
                var label = context.dataset.label || '';
                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += ctx.$options.filters.money(parseFloat(context.parsed.y.toFixed(2)))
                }
                return label;
              },
              title: function(context:any) {
                return 'Year: ' + context[0].label
              }
            }
          },
          legend: {
            display: true,
            labels: {
              color: '#000',
              font: {
                size: 14
              }
            }
          }
        }
      }
    },

    // Variables

    area: function (this:any) {
      return this.scenario.value.areas[this.lifeCycleKey]
    },

    pastureLife: function (this:any) {
      return this.getValue('pastureLife', 'assumptions')
    },

    totalCost: function (this:any) {
      return Math.ceil(this.scenario.value.totals[this.lifeCycleKey].all)
    },

    inflationRate: function (this:any) {
      let inflationRate = this.getValue('annualInflationRate', 'assumptions', this.lifeCycleKey) / 100
      return inflationRate
    },

    discountRate: function (this:any) {
      let discountRate = this.getValue('opportunityCost', 'assumptions', 'perennial') / 100
      if (this.inflationRate === 0 || this.lifeCycleKey === 'shortTerm') {
        return discountRate
      } else {
        return (((discountRate - this.inflationRate) *
        this.inflationRate) +
        this.inflationRate +
        (discountRate - this.inflationRate))
      }
    },

    pastureFailureCost: function (this:any) {
      let pastureFailureCost:any[] = []
      // Seeds
      let seeds = this.scenario.value.costs[this.lifeCycleKey].filter((item:Cost) => {
        return item.section.toLowerCase().indexOf('seed') > -1
      })
      let seedsTotalCost = 0
      seeds.forEach((seed:Cost) => {
        seedsTotalCost += seed.cost
      })
      // Post sow spraying
      let spraying = this.scenario.value.costs[this.lifeCycleKey].filter((item:Cost) => {
        return item.section.toLowerCase().includes('spraying')
      })
      let sprayingTotalCost = 0
      spraying.forEach((spray:Cost) => {
        sprayingTotalCost += spray.cost
      })
      // Chance of Failure (%)
      let chanceOfFailure = this.getValue('chanceOfFailure', 'assumptions') / 100
      let firstYear = ((seedsTotalCost + sprayingTotalCost) * chanceOfFailure) + (this.establishmentAgistmentCost * chanceOfFailure)
      let secondYear = this.establishmentAgistmentCost * chanceOfFailure
      pastureFailureCost = [firstYear, secondYear]
      return pastureFailureCost
    },

    establishmentAgistmentCost: function (this:any) {
      return (52 - this.getValue('grazedWeeks', 'assumptions')) *
      this.getValue('stockingRateBefore', 'assumptions') *
      this.getValue('agistmentCost', 'assumptions')
    },

    residualTotal: function (this:any) {
      let residual = this.scenario.value.assumptions[this.lifeCycleKey].filter((item:Assumption) => {
        return item.section.toLowerCase().indexOf('residual') > -1
      })
      let residualTotal = 0
      residual.forEach((res:Assumption) => {
        if (res.value) {
          residualTotal += parseFloat(res.value)
        }
      })
      return residualTotal
    },

    // Scenario Overview

    twentyYearValues: function (this:any) {
      let values:object = {}

      // Arrays
      // -- Scenario
      let years:number[] = []
      let stockingRates:number[] = []
      let grossMargins:number[] = []
      let environmentalBenifits:number[] = [0, 0]
      let grossAnnualIncomes:number[] = []
      let extraGrossAnnualIncomes:number[] = []
      let inflatedExtraGrossAnnualIncomes:number[] = []
      let establishmentCosts:number[] = [0, this.scenario.value.totals[this.lifeCycleKey].dev]
      let pastureFailureCosts:number[] = [0, this.pastureFailureCost[0], this.pastureFailureCost[1]]
      let establishmentAgistmentCosts:number[] = [0, this.establishmentAgistmentCost]
      let additionalStocks:number[] = [0, 0]
      let additionalAnnualMaintenanceCosts:number[] = [0, 0]
      let grossAnnualCosts:number[] = []
      let inflatedGrossAnnualCosts:number[] = []
      let annualNetIncomes:number[] = []
      let inflatedAnnualNetIncomes:number[] = []
      let cumulativeCashFlows:number[] = []
      // -- Tax
      let taxableIncomes:number[] = []
      let taxes:number[] = []
      let annualNetCashFlowAfterTax:number[] = []
      let cumulativeNetCashFlowAfterTax:number[] = []
      let cumulativeNetCashFlowAfterInterestTax:number[] = []
      // -- Interest
      let borrowedInterests:number[] = []
      let investmentInterests: number[] = [0, 0]
      let totalInterests:number[] = []
      let annualNetCashFlowInitialInvestments:number[] = []
      let discountFactors:number[] = []

      // Variables
      // -- Stocking Rate
      let SR = 0
      let SRBefore = this.getValue('stockingRateBefore', 'assumptions')
      let SRAfter = this.getValue('stockingRateAfter', 'assumptions')
      let SREnd = this.getValue('stockingRateEndOfLife', 'assumptions', 'perennial')
      let SRPeakTime = this.getValue('stockingRateTimeToPeak', 'assumptions', 'perennial')
      let SRDeclineYear = this.getValue('stockingRateDeclineYear', 'assumptions', 'perennial')
      let frequencyOfResowingPasture = this.getValue('frequencyOfResowingPasture', 'assumptions', 'shortTerm', true)
      let chanceOfFailure = this.getValue('chanceOfFailure', 'assumptions') / 100
      // -- Gross Margin
      let GM = 0
      let GMBefore = this.getValue('grossMarginBefore', 'assumptions')
      let GMAfter = this.getValue('grossMarginAfter', 'assumptions')
      // -- Environment Benefits
      let EB = this.getValue('environmentalBenefit', 'assumptions')
      // -- Additional Stock
      let livestockCapital = this.getValue('livestockCapital', 'assumptions')
      let additionalLivestockLabour = this.getValue('additionalLivestockLabour', 'costs')
      // -- Interest & Tax
      let interestBorrowed = this.getValue('interestBorrowed', 'assumptions', 'perennial')
      let interestInvestment = this.getValue('interestInvestment', 'assumptions', 'perennial')
      let marginalTaxRate = this.getValue('marginalTaxRate', 'assumptions', 'perennial')

      // Percentage of stocking rate increase per year up to peak rate
      let stockingIncreasePerYear = [
        [0, 0, 0.9, 0.7, 0.5, 0.4], // year 1 (after improvement)
        [0, 0, 0.1, 0.2, 0.3, 0.3], // year 2
        [0, 0, 0, 0.1, 0.1, 0.1], // year 3
        [0, 0, 0, 0, 0.1, 0.1], // year 4
        [0, 0, 0, 0, 0, 0.1] // year 5
      ]

      // Get values for first and second years
      function firstSecondYears (year:number, before:any, after:any) {
        if (year === 1) {
          return (after - before) *
          stockingIncreasePerYear[year - 1][SRPeakTime] +
          before
        } else if (year === 2) {
          return (after - before) *
          (stockingIncreasePerYear[0][SRPeakTime] +
          stockingIncreasePerYear[1][SRPeakTime]) +
          before
        }
      }

      // Find the improvement rate before peak stocking rate is reached
      function improveRate (before:any, after:any) {
        return (
          (
            (after - before) *
            (stockingIncreasePerYear[0][SRPeakTime] +
            stockingIncreasePerYear[1][SRPeakTime] +
            stockingIncreasePerYear[2][SRPeakTime]) +
            before
          ) -
          (
            (after - before) *
            (stockingIncreasePerYear[0][SRPeakTime] +
            stockingIncreasePerYear[1][SRPeakTime]) +
            before
          )
        )
      }

      // Create array of 21 years with yr = 0 being the stocking rate before improvement
      for (let yr = 0; yr <= 20; yr++) {
        // Start
        if (yr === 0) {
          SR = SRBefore
          GM = GMBefore
        // Improvement (first & second year)
        } else if (yr <= 2) {
          SR = firstSecondYears(yr, SRBefore, SRAfter)
          GM = firstSecondYears(yr, GMBefore, GMAfter)
        // Improvement (before peak)
        } else if (yr > 2 && yr < SRPeakTime) {
          SR += improveRate(SRBefore, SRAfter)
          GM += improveRate(GMBefore, GMAfter)
        // Peak
        } else if (yr >= SRPeakTime && yr < SRDeclineYear) {
          SR = SRAfter
          GM = GMAfter
        // Decline (after peak)
        } else if (yr <= this.pastureLife) {
          SR = SR - ((SRAfter - SREnd) / (this.pastureLife - (SRDeclineYear - 1)))
          GM = (GMAfter - GMBefore) * ((SR - SRBefore) / (SRAfter - SRBefore)) + GMBefore
        } else {
          SR = 0
          GM = 0
        }
        // Short term
        if (this.lifeCycleKey === 'shortTerm') {
          SR = SR = yr <= this.pastureLife ? SRAfter : 0
          GM = GM = yr <= this.pastureLife ? GMAfter : 0
          if (yr === 1) {
            environmentalBenifits[yr] = EB
            additionalStocks[yr] = (SR - SRBefore) * livestockCapital
          }
        }

        // Push new values to arrays
        years.push(yr)
        stockingRates.push(SR || 0)
        grossMargins.push(GM)

        // -- Scenario
        if (yr >= 2) {
          environmentalBenifits.push(EB)
          establishmentCosts.push(0)
          establishmentAgistmentCosts.push(0)
          additionalAnnualMaintenanceCosts.push(0)
          if (this.lifeCycleKey === 'shortTerm') {
            let frequency = frequencyOfResowingPasture === 'Annually' ? 1 : frequencyOfResowingPasture === 'Every 2nd year' ? 2 : 3
            if ((yr + frequency - 1) % frequency === 0) {
              let ec = 0
              this.scenario.value.costs[this.lifeCycleKey].map((item:Cost) => {
                if (item.section === 'Paddock infrastructure') {
                  ec += item.cost
                }
              })
              establishmentCosts[yr] = this.scenario.value.totals[this.lifeCycleKey].dev - (ec / this.area)
              establishmentAgistmentCosts[yr] = this.establishmentAgistmentCost
            }
            additionalAnnualMaintenanceCosts[yr] = (
              establishmentCosts[yr] > 0
                ? 0
                : (
                  (this.scenario.value.totals[this.lifeCycleKey].main/* - additionalLivestockLabour * SRAfter*/) +
                  (stockingRates[yr] > SRBefore ? (stockingRates[yr] - SRBefore) * additionalLivestockLabour : 0)
                )
            )
            pastureFailureCosts[yr] = (
              establishmentCosts[yr] > 0
              ? pastureFailureCosts[1]
              : (
                establishmentCosts[yr - 1] > 0
                  ? establishmentAgistmentCosts[yr - 1] * chanceOfFailure
                  : 0
                )
            )
          } else {
            additionalAnnualMaintenanceCosts[yr] = (this.scenario.value.totals[this.lifeCycleKey].main - additionalLivestockLabour * SRAfter) +
            (stockingRates[yr] > SRBefore ? (stockingRates[yr] - stockingRates[0]) * additionalLivestockLabour : 0)
          }
          if (yr === this.pastureLife) {
            environmentalBenifits[yr] = (stockingRates[yr] - SRBefore) * livestockCapital + EB + this.residualTotal
          }
          if (yr === 2) {
            additionalStocks.push((stockingRates[yr] - stockingRates[0]) * livestockCapital)
          } else {
            additionalStocks.push((stockingRates[yr] - stockingRates[yr - 1]) * livestockCapital)
            pastureFailureCosts.push(0)
          }
        }

        // -- Gross Incomes
        grossAnnualIncomes.push((stockingRates[yr] * grossMargins[yr]) + environmentalBenifits[yr])
        extraGrossAnnualIncomes.push(grossAnnualIncomes[yr] - grossAnnualIncomes[0])
        if (this.lifeCycleKey === 'shortTerm') {
          extraGrossAnnualIncomes[yr] = grossAnnualIncomes[yr] - ((yr <= this.pastureLife ? SRBefore : 0) * GMBefore)
        }
        inflatedExtraGrossAnnualIncomes.push(this.inflate(extraGrossAnnualIncomes[yr], yr))

        // -- Gross Costs
        grossAnnualCosts.push(establishmentCosts[yr] + pastureFailureCosts[yr] + establishmentAgistmentCosts[yr] + additionalStocks[yr] + additionalAnnualMaintenanceCosts[yr])
        inflatedGrossAnnualCosts.push(this.inflate(grossAnnualCosts[yr], yr))

        // -- Annual Net Incomes
        annualNetIncomes.push(extraGrossAnnualIncomes[yr] - grossAnnualCosts[yr])
        inflatedAnnualNetIncomes.push(this.inflate(annualNetIncomes[yr], yr))

        // -- Cummulative Cash Flows
        if (yr > 1) {
          cumulativeCashFlows.push(cumulativeCashFlows[yr - 1] + inflatedAnnualNetIncomes[yr])
        } else {
          cumulativeCashFlows.push(inflatedAnnualNetIncomes[yr])
        }

        // -- Taxes & Interests
        let interestTypeBI = inflatedAnnualNetIncomes[yr] < 0 ? interestBorrowed : interestInvestment
        borrowedInterests.push(interestTypeBI * inflatedAnnualNetIncomes[yr] * 0.55 / 100)

        if (yr === 1) {
          investmentInterests[yr] = 0
          totalInterests[yr] = borrowedInterests[yr]
          if (this.lifeCycleKey === 'shortTerm') {
            taxableIncomes[yr] = (
              inflatedExtraGrossAnnualIncomes[yr] -
              this.inflate(environmentalBenifits[yr], yr) -
              inflatedGrossAnnualCosts[yr] +
              totalInterests[yr] +
              this.inflate(additionalStocks[yr], yr)
            )
          } else {
            taxableIncomes[yr] = (
              inflatedExtraGrossAnnualIncomes[yr] -
              this.inflate(environmentalBenifits[yr], yr) -
              inflatedGrossAnnualCosts[yr] +
              totalInterests[yr] +
              this.inflate(additionalStocks[yr], yr) +
              0.9 *
              this.scenario.value.totals[this.lifeCycleKey].dev
            )
          }
          taxes[yr] = taxableIncomes[yr] * marginalTaxRate / 100
          annualNetCashFlowAfterTax[yr] = inflatedAnnualNetIncomes[yr] - taxes[yr]
          cumulativeNetCashFlowAfterTax[yr] = annualNetCashFlowAfterTax[yr]
          cumulativeNetCashFlowAfterInterestTax[yr] = cumulativeNetCashFlowAfterTax[yr] + totalInterests[yr]
          annualNetCashFlowInitialInvestments[yr] = annualNetCashFlowAfterTax[yr] + pastureFailureCosts[yr] + this.scenario.value.totals[this.lifeCycleKey].dev
        }

        if (yr > 1) {
          let interestTypeII = cumulativeNetCashFlowAfterTax[yr - 1] < 0 ? interestBorrowed : interestInvestment
          investmentInterests[yr] = interestTypeII * cumulativeNetCashFlowAfterTax[yr - 1] / 100
          totalInterests[yr] = borrowedInterests[yr] + investmentInterests[yr]
          if (this.lifeCycleKey === 'shortTerm') {
            taxableIncomes[yr] = (
              inflatedExtraGrossAnnualIncomes[yr] -
              this.inflate(environmentalBenifits[yr], yr) -
              inflatedGrossAnnualCosts[yr] +
              totalInterests[yr] +
              this.inflate(additionalStocks[yr], yr)
            )
          } else {
            taxableIncomes[yr] = (
              inflatedExtraGrossAnnualIncomes[yr] -
              this.inflate(environmentalBenifits[yr], yr) -
              inflatedGrossAnnualCosts[yr] +
              totalInterests[yr] +
              this.inflate(additionalStocks[yr], yr) -
              (yr < SRDeclineYear ? 0.1 * this.scenario.value.totals[this.lifeCycleKey].dev : 0)
            )
          }
          taxes[yr] = taxableIncomes[yr] * marginalTaxRate / 100
          annualNetCashFlowAfterTax[yr] = inflatedAnnualNetIncomes[yr] - taxes[yr]
          cumulativeNetCashFlowAfterTax[yr] = cumulativeNetCashFlowAfterTax[yr - 1] + annualNetCashFlowAfterTax[yr] + totalInterests[yr - 1]
          cumulativeNetCashFlowAfterInterestTax[yr] = cumulativeNetCashFlowAfterTax[yr] + totalInterests[yr]
          annualNetCashFlowInitialInvestments[yr] = annualNetCashFlowAfterTax[yr]
        }

        discountFactors.push(1 / Math.pow((1 + this.discountRate), yr))
      }

      // Create values object containing each array
      values = {
        year: { array: years, money: false, fixed: 0 },
        stockingRate: { array: stockingRates, money: false, fixed: 1 },
        grossMargin: { array: grossMargins, money: true, fixed: 0 },
        environmentalBenefit: { array: environmentalBenifits, money: true, fixed: 0 },
        grossAnnualIncome: { array: grossAnnualIncomes, money: true, fixed: 0 },
        extraGrossAnnualIncome: { array: extraGrossAnnualIncomes, money: true, fixed: 0 },
        inflatedExtraGrossAnnualIncome: { array: inflatedExtraGrossAnnualIncomes, money: true, fixed: 0 },
        establishmentCost: { array: establishmentCosts, money: true, fixed: 0 },
        pastureFailureCost: { array: pastureFailureCosts, money: true, fixed: 0 },
        establishmentAgistmentCost: { array: establishmentAgistmentCosts, money: true, fixed: 0 },
        additionalStock: { array: additionalStocks, money: true, fixed: 0 },
        additionalAnnualMaintenanceCost: { array: additionalAnnualMaintenanceCosts, money: true, fixed: 0 },
        grossAnnualCost: { array: grossAnnualCosts, money: true, fixed: 0 },
        inflatedGrossAnnualCost: { array: inflatedGrossAnnualCosts, money: true, fixed: 0 },
        annualNetIncome: { array: annualNetIncomes, money: true, fixed: 0 },
        inflatedAnnualNetIncome: { array: inflatedAnnualNetIncomes, money: true, fixed: 0 },
        cumulativeCashFlow: { array: cumulativeCashFlows, money: true, fixed: 0 },
        taxableIncome: { array: taxableIncomes, money: true, fixed: 0 },
        tax: { array: taxes, money: true, fixed: 0 },
        annualNetCashFlowAfterTax: { array: annualNetCashFlowAfterTax, money: true, fixed: 0 },
        cumulativeNetCashFlowAfterTax: { array: cumulativeNetCashFlowAfterTax, money: true, fixed: 0 },
        cumulativeNetCashFlowAfterInterestTax: { array: cumulativeNetCashFlowAfterInterestTax, money: true, fixed: 0 },
        interestOnMoneyBorrowedDuringYear: { array: borrowedInterests, money: true, fixed: 0 },
        cumulativeDebtInterest: { array: investmentInterests, money: true, fixed: 0 },
        totalInterestOnCumulativeCashFlow: { array: totalInterests, money: true, fixed: 0 },
        annualNetCashFlowInitialInvestment: { array: annualNetCashFlowInitialInvestments, money: true, fixed: 0 },
        discountFactor: { array: discountFactors, money: false, fixed: 2 }
      }
      return values
    },

    // Results

    NPV: function (this:any) {
      if (this.area <= 0) {
        return 0
      } else {
        let rate = this.discountRate * 100
        let initialInvestment = 0
        let cashFlows = this.twentyYearValues.annualNetCashFlowAfterTax.array.slice(1, this.pastureLife + 1)
        let list = cashFlows
        list.unshift(initialInvestment)
        list.unshift(rate)
        return this.finance.NPV.apply(this, list)
      }
    },

    IRR: function (this:any) {
      let positives = this.twentyYearValues.annualNetCashFlowAfterTax.array.filter((e:any) => {
        return e > 0
      })
      let negatives = this.twentyYearValues.annualNetCashFlowAfterTax.array.filter((e:any) => {
        return e < 0
      })
      let initialInvestment = 0
      let cashFlows = this.twentyYearValues.annualNetCashFlowAfterTax.array.slice(1, this.pastureLife + 1)
      let list = cashFlows
      list.unshift(initialInvestment)
      if (positives.length > 0 && negatives.length > 0) {
        try {
          this.finance.IRR.apply(this, list)
          return this.finance.IRR.apply(this, list)
        } catch (error) {
          // console.error(error)
          return 0
        }
      }
      return 0
    },

    peakDebt: function (this:any) {
      if (this.area <= 0) {
        return 0
      } else {
        let cashFlows = this.twentyYearValues.cumulativeNetCashFlowAfterInterestTax.array.slice(1, this.pastureLife + 1)
        return Math.min.apply(null, cashFlows)
      }
    },

    peakDebtYear: function (this:any) {
      if (this.twentyYearValues.cumulativeNetCashFlowAfterInterestTax.array.indexOf(this.peakDebt) >= 0) {
        return this.twentyYearValues.cumulativeNetCashFlowAfterInterestTax.array.indexOf(this.peakDebt)
      }
      return 0
    },

    breakEvenYear: function (this:any) {
      let positives = this.twentyYearValues.cumulativeNetCashFlowAfterInterestTax.array.slice(1, 21)
      //let sum = 0
      positives = positives.map((value:number, year:number) => {
        //sum += value
        //if (sum > 0) {
        if (value > 0) {
          return year
        } else {
          return 0
        }
      })
      return positives.find((element:number) => element > 0) + 1
    }
  },

  methods: {
    getValue: function (this:any, value:string, table:string, lifeCycle?:string, text?:boolean) {
      let LC = lifeCycle || this.lifeCycleKey
      if (table === 'costs') {
        let costs = this.scenario.value.costs[LC].map((cost:Cost) => cost.id)
        return parseFloat(this.scenario.value.costs[LC][costs.indexOf(value)].cost)
      }
      if (table === 'assumptions') {
        let assumptions = this.scenario.value.assumptions[LC].map((assumption:Assumption) => assumption.id)
        if (text) {
          return this.scenario.value.assumptions[LC][assumptions.indexOf(value)].value
        }
        return parseFloat(this.scenario.value.assumptions[LC][assumptions.indexOf(value)].value)
      }
    },

    inflate: function (this:any, value:number, year:number) {
      return value * Math.pow((this.inflationRate + 1), year)
    },

    // Select scenario
    selectScenario: function (this:any, event:any) {
      // console.log('this.scenario', this.scenario)
      // console.log('store.state.selectedScenario', store.state.selectedScenario)
      // console.log('event', event)
      // console.log(store.state.scenarios.filter((ss:any) => ss.text === event.name)[0])*/
      if (event !== undefined) {
        store.dispatch('updateSelectedScenario', store.state.scenarios.filter((ss:any) => ss.text === event.name)[0])
        this.scenario = store.state.selectedScenario
        this.scenarioLifeCycle = this.scenario.value.lifeCycle
      }
    },
  },

  store
}
